import { Input } from '@chiroup/components/form/Input';
import { Select } from '@chiroup/components/form/Select';
import {
  LEGAL_GUARDIAN_RELATIONSHIP_OPTIONS,
  LEGAL_GUARDIAN_RELATIONSHIP_SPANISH_OPTIONS,
} from '@chiroup/core/constants/globals';
import { FormFieldErrors } from '@chiroup/core/types/ErrorResponse.type';
import { Patient } from '@chiroup/core/types/Patient.type';
import { ValueOf } from '@chiroup/core/types/ValueOf.type';

type Props = {
  fieldErrors?: FormFieldErrors;
  onChange: (key: keyof Partial<Patient>) => (val: ValueOf<Patient>) => void;
  values: Partial<Patient>;
  update?: boolean;
  spanish?: boolean;
};

export const LegalGuardianFields: React.FC<Props> = ({
  fieldErrors,
  onChange,
  values,
  update,
  spanish = false,
}) => {
  return (
    <>
      <Input
        className={update ? 'col-span-6' : 'col-span-6'}
        name="legalGuardianName"
        label={spanish ? 'Nombre del tutor legal *' : 'Legal guardian name *'}
        value={values.legalGuardianName}
        onChange={onChange('legalGuardianName')}
        errors={fieldErrors?.legalGuardianName}
      />
      <Select
        className={update ? 'col-span-6' : 'col-span-6'}
        name="legalGuardianRelationship"
        label={spanish ? 'Relación con el tutor legal *' : 'Legal guardian relationship *'}
        placeholder={spanish ? 'Seleccionar...' : undefined}
        value={values.legalGuardianRelationship}
        onChange={onChange('legalGuardianRelationship')}
        errors={fieldErrors?.legalGuardianRelationship}
        options={
          spanish
            ? LEGAL_GUARDIAN_RELATIONSHIP_SPANISH_OPTIONS
            : LEGAL_GUARDIAN_RELATIONSHIP_OPTIONS
        }
      />
    </>
  );
};
